import { IQuickLinksSectionEntry } from '../../../shared/api/contentful/types';

export const MERGED_QUICK_LINK_SECTIONS_TYPE_ID = 'merged-quick-links-section';

export interface IMergedQuickLinksSection {
	id: string;
	contentType: typeof MERGED_QUICK_LINK_SECTIONS_TYPE_ID;
	sections: IQuickLinksSectionEntry[];
}
